// src/PrescriptionSuccess.js
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import api from "../utils/api"; // Assuming you have an API utility
import "./PrescriptionSuccess.css";

const PrescriptionSuccess = () => {
  const { doctorUser } = useContext(AuthContext);
  const urlParams = new URLSearchParams(window.location.search);
  const appointmentId = urlParams.get("appointmentId");
  const [patientName, setPatientName] = useState("Unknown Patient");

  useEffect(() => {
    const fetchAppointment = async () => {
      if (!appointmentId || !doctorUser) return;
      try {
        const response = await api.get(`/appointments/${appointmentId}`, {
          headers: { Authorization: `Bearer ${doctorUser.accessToken}` },
        });
        setPatientName(response.data.patientId?.name || "Unknown Patient");
      } catch (err) {
        console.error("Failed to fetch appointment:", err);
      }
    };
    fetchAppointment();
  }, [appointmentId, doctorUser]);

  const handleBackToDashboard = () => {
    if (doctorUser?.id) {
      window.location.href = `/doctor-dashboard/${doctorUser.id}`;
    } else {
      window.location.href = "/doctor-login";
    }
  };

  return (
    <div className="prescription-success-container">
      <div className="prescription-success-card">
        <div className="prescription-success-icon">✓</div>
        <h1 className="prescription-success-title">Prescription Sent Successfully</h1>
        <p className="prescription-success-text">
          Your prescription has been sent to {patientName}. They will receive it shortly.
        </p>
        <button className="prescription-success-btn" onClick={handleBackToDashboard}>
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PrescriptionSuccess;